<template>
  <div>
    <PageHeader class="mb-12">
      <div class="mx-auto w-full max-w-screen-lg text-white">
        <h2 class="am-heading text-2xl font-bold">
          {{ pageTitle }}
        </h2>
      </div>
    </PageHeader>

    <div class="mx-auto w-full max-w-screen-lg pb-16">
      <!-- <ContactForm class="mb-20" />
      <hr /> -->
      <div class="text-center">
        <h3>Customer Support</h3>
        <p>
          <a href="mailto:support@astronomerch.com">support@astronomerch.com</a>
        </p>

        <h3>Press Inquiries</h3>
        <p>
          <a href="mailto:press@astronomerch.com">press@astronomerch.com</a>
        </p>
        <h3>Vendor Inquiries</h3>
        <p>
          <a href="mailto:vendors@astronomerch.com">vendors@astronomerch.com</a>
        </p>
      </div>
    </div>
  </div>
</template>

<script setup>
const pageTitle = ref("Contact")
</script>
